<template>
  <div class="footer-box" v-if="isShowFooter()" style="background-color: #292b32;">
    <div style="fill: #292b32">
      <svg width="100%" height="56" viewBox="0 0 440 56" class="h-auto w-full" xmlns="http://www.w3.org/2000/svg">
        <path d="M193.128 7.89437C191.885 3.65469 188.418 0 184 0H16C7.16344 0 0 7.16344 0 16V56H440V16C440 7.16344 432.837 0 424 0H256C251.582 0 248.115 3.65469 246.872 7.89437C243.463 19.5146 232.723 28 220 28C207.277 28 196.537 19.5146 193.128 7.89437Z"></path>
      </svg>
    </div>
    <div style="position: absolute; left: 0px; top: 8px">
      <div class="footer-box-item" @click="toPage('/')">
        <img v-if="pagename == '/'" src="/static/image/footer/home_active.webp" />
        <img v-else src="/static/image/footer/home.webp" />
        <p :style="pagename == '/' ? 'color:#cca352;':''">首页</p>
      </div>
      <div class="footer-box-item" @click="toPage('/activeList')">
        <img v-if="pagename == '/activeList'" src="/static/image/footer/promotions_active.webp" />
        <img v-else src="/static/image/footer/promotions.webp" />
        <p :style="pagename == '/activeList' ? 'color:#cca352;':''">活动</p>
      </div>
      <div class="footer-box-item" @click="toPage('/deposit')">
        <div style="background: linear-gradient(224deg,#cca352,#ffcb4c); width: 44px; height: 44px; border-radius: 50%; text-align: center; position: absolute; left: calc((100% - 44px) / 2); top: -30px">
          <img src="/static/image/footer/deposit.webp" style="margin-top: 8px" />
        </div>
        <p  :style="pagename == '/deposit' ? 'color:#cca352;':''" style="margin-top: 30px">存款</p>
      </div>
      <div class="footer-box-item" @click="toPage('/assets')">
        <img v-if="pagename == '/assets'" src="/static/image/footer/washCode_active.webp" />
        <img v-else src="/static/image/footer/washCode.webp" />
        <p :style="pagename == '/assets' ? 'color:#cca352;':''">转账</p>
      </div>
      <div class="footer-box-item" @click="toPage('/userCenter')">
        <img v-if="pagename == '/userCenter'" src="/static/image/footer/mine_active.webp" />
        <img v-else src="/static/image/footer/mine.webp" />
        <p :style="pagename == '/userCenter' ? 'color:#cca352;':''">我的</p>
      </div>
    </div>
    <div v-if="iosshow" style="position: absolute; top: -70px;background-color: #141414;padding: 4px 10px;width: 160px;left: calc((100vw - 160px) / 2);border-radius: 10px;border: 1px solid #ddd;">
        <span @click="toshow=true"><van-icon name="add-o"  /> 添加到桌面</span> | <span @click="iosshow=false">关闭</span>
    </div>
    <van-popup v-model="toshow" style="border-radius: 10px;" round closeable>
        <div style="background-color: #292B32;color:#7F7A80;padding: 20px;border: 1px solid #292B32;border-radius: 10px;line-height: 2;">
            <div style="height: 35px;line-height: 35px;font-size: 18px;color: #fff;">点击”添加到主屏幕“按钮</div>
            <div>保持轻量版至手机桌面</div>
            <div>第一步： 使用Safari浏览器打开网站</div>
            <div>
                <img src="/static/image/tabs/addToHome_1.54d1c7f0.svg" />
            </div>
            <div>第一步： 往下滑找到<span style="color: #cca352;">[添加到主屏幕]</span>选项</div>
            <div>
                <img src="/static/image/tabs/addToHome_2.90b1dab2.svg" />
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'FooterView',
  data () {
    return {
      active: null,
      pagename:this.$route.path,
      iosshow:false,
      toshow:false
    };
  },
  watch:{
    pagename(val){
        
    }
  },
  mounted(){
    this.pagename = this.$route.path
    this.isAndroidOrIOS()
  },
  methods:{
    isShowFooter(){
        return  this.$route.path == '/' ||  this.$route.path == '/activeList' ||  this.$route.path == '/deposit' ||  this.$route.path == '/assets' ||  this.$route.path == '/userCenter' 
    },
    toPage(val){
        this.pagename = val
        this.$parent.goNav(val)
    },
    isAndroidOrIOS () {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
     
      if (isiOS) {
        this.iosshow = true
      }
    }
  }
};
</script>
<style scoped>
.footer-box {
  position: fixed;
  height: 56px;
  width: 100vw;
  left: 0px;
  bottom: 0px;
  z-index: 900;
  text-align: center;
  color: #fff;
}
.footer-box-item {
  width: calc(100vw / 5);
  height: 56px;
  float: left;
  border: none;
  color: #7f7a80;
  position: relative;
}
.footer-box-item img {
  width: 27px;
  height: 27px;
}
.footer-box-item p {
  line-height: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/libs/Footer.vue